import React from 'react';

interface IPageActionBarProps {
    rightBar?: React.ReactNode;
    leftBar?: React.ReactNode;
}

export const PageActionBar: React.FC<IPageActionBarProps> = ({rightBar, leftBar}) => (
    <div className="d-flex justify-content-between">
        <div>
            {rightBar}
        </div>
        <div>
            {leftBar}
        </div>
    </div>
);
